import type { ClosedReasonType } from './ClosedReasonType';

export class ClosedReason {
  constructor(
    readonly type: ClosedReasonType,
    readonly label = '',
  ) {}
}
